import * as React from "react";
import styled from "styled-components";

import NavbarDropdown from "./NavbarDropdown";
import { NavStructurePropTypes } from "../../vars";

class Navbar extends React.Component<any, any> {
  static propTypes = {
    ...NavStructurePropTypes
  };

  renderNavbarDropdown = (navItem, index) => (
    <NavbarDropdown
      icon={navItem.label.icon}
      smallIcon={navItem.label.smallIcon}
      menuItems={navItem.menuItems}
      key={index + navItem.label}
      menuId={navItem.label.text.replace(/ /g, "_")}
      menuLabel={navItem.label.text}
      aria-label={navItem.label.text}
    >
      {navItem.label.text}
    </NavbarDropdown>
  );

  render() {
    const { navStructure, className } = this.props;

    const navDropdowns = navStructure.map(this.renderNavbarDropdown);

    return (
      <div className={className} aria-label="Main Menu" role="menubar">
        {navDropdowns}
      </div>
    );
  }
}

export default styled(Navbar)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
